<template>
  <div :class="customClass" style="height: 100%">
    <div id="page-loading" v-if="!loaded" style="height: 100%"></div>
    <slot v-if="loaded && !err"></slot>
    <error-page
      v-if="err"
      :description="err.message || '系统繁忙，请稍后重试'"
    ></error-page>
  </div>
</template>

<script>
/**
 * 支持初始化 loading 和 错误页
 * setup 初始化请求，页面强依赖的接口，如果此请求出错，直接显示错误页
 * title 页面标题
 */
import { Loading } from 'element-ui';

export default {
  props: {
    setup: {
      type: Function,
      default: function() {
        return async () => void 0;
      }
    },
    customClass: String
  },
  data() {
    return {
      err: null,
      loaded: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const loading = Loading.service({
        target: '#page-loading'
      });
      try {
        await this.setup();
      } catch (e) {
        //console.log(e);
        this.err = e;
      }
      loading.close();
      this.loaded = true;
    }
  }
};
</script>
